<!--
 * @Author: Latte
 * @Date: 2021-09-09 16:03:54
 * @LAstEditors: Latte
 * @LastEditTime: 2021-12-15 13:51:22
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\FileManagement\File\fileCategory.vue
-->
<template>
  <div class="app-container">
    <div class="main">
      <!--本组件已弃用-->
      <!-- 资料类型工具栏 -->
      <div class="topbar">
        <div class="left"><p style="line-height:2em;color: gray" ><i class="el-icon-warning-outline" style="color: red"></i>不同的<a style="color: blue">角色</a>在不同的资料类型下有不同的<a style="color: blue">访问权限</a>。在<a style="color: blue">新增/编辑资料类型</a>时，需为角色分配相应的访问权限。 </p>
        </div>
        <div class="right">
          <el-button
            type="primary"
            size="small"
            style="margin-top: 10px"
            title="Add Category"
            icon="el-icon-plus"
            @click="openAddFileCategoryDialog()"
            >添加资源类型
          </el-button>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        v-loading="loading"
        :data="fileCategoryList"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px"
        stripe
        border
      >
        <el-table-column
          prop="csFileTypeID"
          label="ID"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column prop="typeName" label="类型名称" align="center">
        </el-table-column>
        <el-table-column
          prop="typeDesc"
          label="描述"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="角色访问权限" align="center" width="110">
          <template slot-scope="scope">
            <el-button
                    :disabled="!scope.row.roleList.length"
                    type="info"
                    size="small"
                    title="查看资料类型所绑定的角色权限"
                    icon="el-icon-tickets"
                    @click.stop="viewFileAccess(scope.row.roleList)"
            >
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="operation"
          label="操作"
          align="center"
          width="250"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              title="Edit Category"
              @click="openEditFileCategoryDialog(scope.row)"
            >设置权限
            </el-button>
            <el-button
              type="danger"
              size="small"
              title="Delete Category"
              @click="deleteFileCategory(scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div v-show="totalCount > pageSize" class="pagination">
        <el-pagination
          v-show="fileCategoryList.length > 0"
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="totalCount"
          :current-page="currentPage"
          @current-change="currentChange"
        />
        <!-- 添加资料类型 -->
        <el-dialog
                title="新增资料类型"
                :visible.sync="addFileCategoryDialog"
                :modal="false"
                width="40%"
        >
          <el-form :model="addFileCategoryForm">
            <el-form-item label="资料类型名称" :label-width="labelWidth" required>
              <el-input v-model="addFileCategoryForm.name"></el-input>
            </el-form-item>
            <el-form-item label="资料类型描述" :label-width="labelWidth">
              <el-input
                      type="textarea"
                      rows="2"
                      v-model="addFileCategoryForm.desc"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户角色权限分配"  :label-width="labelWidth"></el-form-item>
            <p style="line-height:2em;color: gray" ><i class="el-icon-warning-outline" style="color: red"></i>客服文档<a style="color: blue">用户角色</a>需要在：系统管理->客服文档管理->用户->用户角色页设置 </p>
            <el-form-item
                    :label="item.roleName"
                    :label-width="labelWidth"
                    v-for="(item, index) of addFileCategoryForm.roleList"
                    :key="index"
            >
              <el-select v-model="item.permissionType" clearable style="width: 100%">
                <el-option label="不可访问、不可下载" :value="0"> </el-option>
                <el-option label="可访问、不可下载" :value="1"> </el-option>
                <el-option label="可访问、可下载" :value="2"> </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button size="small" @click="addFileCategoryDialog = false">
              取消
            </el-button>
            <el-button type="primary" size="small" @click="addFileCategory()">
              确认
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- 编辑资料类型 -->
    <el-dialog
      title="编辑资料类型"
      :visible.sync="editFileCategoryDialog"
      :modal="false"
      width="40%"
    >
      <el-form :model="editFileCategoryForm">
        <el-form-item label="资料类型名称" :label-width="labelWidth" required>
          <el-input v-model="editFileCategoryForm.typeName"></el-input>
        </el-form-item>
        <el-form-item label="资料类型描述" :label-width="labelWidth">
          <el-input
            type="textarea"
            rows="2"
            v-model="editFileCategoryForm.typeDesc"
          ></el-input>
        </el-form-item>
        <el-form-item label=" 用户角色权限分配" :label-width="labelWidth">
        </el-form-item>
        <el-form-item
          :label="item.roleName"
          :label-width="labelWidth"
          v-for="(item, index) of editFileCategoryForm.roleList"
          :key="index"
        >
          <el-select v-model="item.permissionType" style="width: 100%">
            <el-option label="不可访问、不可下载" :value="0"> </el-option>
            <el-option label="可访问、不可下载" :value="1"> </el-option>
            <el-option label="可访问、可下载" :value="2"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editFileCategoryDialog = false">
          取消
        </el-button>
        <el-button type="primary" size="small" @click="editFileCategory()">
          确认
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="角色权限" :visible.sync="roleListDialog" :modal="false" width="60%">
      <el-table :data="accessList" style="width: 100%">
        <el-table-column prop="roleName" label="角色名称" align="center">
        </el-table-column>
        <el-table-column prop="readAccess" label="读权限" align="center">
        </el-table-column>
        <el-table-column  prop="downloadAccess" label="下载权限" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getFileCategoryList,
  addFileCategory,
  editFileCategory,
  deleteFileCategory,
} from "@/api/system/CSDocument/file";
import {getCSRoleList} from "@/api/system/CSDocument/user"

export default {
  data() {
    return {
      roleListDialog: false, // 角色权限列表对话框开关
      accessList:[],
      roleList:[],
      loading: false, // 加载开关
      totalCount: 0, // 总数
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      labelWidth: "135px", // 标签宽度
      fileCategoryList: [], // 文件类别列表
      addFileCategoryDialog: false, // 添加文件类别对话框开关
      addFileCategoryForm: {}, // 添加文件类别对话框开关
      editFileCategoryDialog: false, // 编辑文件类别对话框开关
      editFileCategoryForm: {}, // 编辑文件类别对话框开关
    };
  },
  created() {
    this.getFileCategoryList();
    this.getUserRoleList();
  },
  methods: {

    viewFileAccess(row) {
      this.accessList=[];
      if(row !==null) {
        for (const role of row) {
          let roleAccess = {
            roleName: role.roleName,
            readAccess: (role.permissionType === 1 || role.permissionType === 2) ? "√" : "×",
            downloadAccess: role.permissionType === 2 ? "√" : "×",
          };
          this.accessList.push(roleAccess);
        }
        this.roleListDialog = true;
      }
    },

    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getFileCategoryList();
    },
    /**
     * 获取文件类别列表
     */
    getFileCategoryList() {
      let params = {
        sortName: "",
        sortOrder: "asc",
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyword: "",
        where: "",
      };
      this.loading = true;

      getFileCategoryList(params).then((res) => {
        console.log(res);
        this.fileCategoryList=[]
        for(const temp of res.data.rows){
            if (temp.deleteTime === null){
              this.fileCategoryList.push(temp);
            }
        }
        this.totalCount = res.data.total;
        this.utils.stopLoading(this);
      });
    },
    /**
     * 获取用户角色
     */
    getUserRoleList() {
      return new Promise((resolve, reject) => {
        const params = {
          orderBy:"",
          orderType:"",
          pageNumber: 1,
          pageSize: 99,
        };
        getCSRoleList(params).then((res) => {
          this.$set(this.addFileCategoryForm, "roleList", res.data.result);
          //此处添加默认权限
          if(this.addFileCategoryForm.roleList!==null){
            for (const temp of this.addFileCategoryForm.roleList){
              temp.permissionType=0;
            }
          }
          this.roleList=res.data.result;
          resolve("getUserRoleList done");
        });
      });
    },
    /**
     * 打开添加文件类别对话框
     */
    openAddFileCategoryDialog() {
      // 初始化
      this.$set(this.addFileCategoryForm, "userDataType", 0);

      this.getUserRoleList().then((res) => {
        console.log(res);
        this.addFileCategoryDialog = true;
      });
    },
    /**
     * 添加文件类别
     */
    addFileCategory() {
      // 表单验证
      if (!this.addFileCategoryForm.name) {
        this.$message({
          message: "类别名称不能为空",
          type: "warning",
        });
        return;
      }
      const roleList=[]
      if(this.addFileCategoryForm.roleList!==[]){
        for(const temp of this.addFileCategoryForm.roleList){
          roleList.push({csFileRoleID:temp.roleID,permissionType:temp.permissionType});
        }
      }

      const data = {
        typeName: this.addFileCategoryForm.name,
        typeDesc: this.addFileCategoryForm.desc,
        userDataType: 2,
        roleList: roleList,
      };
      addFileCategory(data).then(() => {
        this.$message({
          message: "Operate success",
          type: "success",
        });
        this.addFileCategoryDialog = false;
        this.addFileCategoryForm.name = null;
        this.addFileCategoryForm.desc = null;
        this.addFileCategoryForm.roleList = null;
        this.getFileCategoryList();
      });
    },
    /**
     * 打开编辑文件类别对话框
     *
     * @param {object} row 选中对象
     */
    openEditFileCategoryDialog(row) {
      // 初始化
      console.log(row);
      console.log("xixi");
      this.editFileCategoryForm = {};
      this.editFileCategoryForm = row;
      const roleList=[];
      for(const temp of this.roleList){
        roleList.push({csFileRoleID:temp.roleID,roleName:temp.roleName,permissionType:''})
      }
      if (row.roleList !== null && row.roleList !== []) {
        for (const temp of row.roleList) {
          for (const tempRole of roleList) {
            if (temp.roleID === tempRole.csFileRoleID) {
              tempRole.permissionType = temp.permissionType;
              break;
            }
          }
        }
      }
      this.editFileCategoryForm.roleList=roleList;

      this.editFileCategoryDialog = true;
    },
    /**
     * 编辑文件类别
     */
    editFileCategory() {
      // 表单验证
      if (!this.editFileCategoryForm.typeName) {
        this.$message({
          message: "类别名称不能为空",
          type: "warning",
        });
        return;
      }

      const data = {
        csFileTypeID: this.editFileCategoryForm.csFileTypeID,
        typeName: this.editFileCategoryForm.typeName,
        typeDesc: this.editFileCategoryForm.typeDesc,
        userDataType: this.editFileCategoryForm.userDataType,
        roleList: this.editFileCategoryForm.roleList,
      };
      editFileCategory(data).then(() => {
        this.$message({
          message: "Operate success",
          type: "success",
        });
        this.editFileCategoryDialog = false;
        this.getFileCategoryList();
      });
    },
    /**
     * 删除文件类别
     *
     * @param {object} row 选中对象
     */
    deleteFileCategory(row) {
      let params = {
        csFileTypeID: row.csFileTypeID,
      };
      this.$confirm("您要删除此资料类型吗？", this.$t("tips"), {
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        type: "warning",
      })
        .then(() => {
          deleteFileCategory(params).then(() => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getFileCategoryList();
          });
        })
        .catch(() => {
          this.$message("取消操作");
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
